<template>
  <div>
    <slot v-if="preview" name="preview">
      Preview......
    </slot>
    <slot v-else></slot>
  </div>
</template>

<script>
export default {
  computed: {
    preview() {
      return window.location.search.includes("mode=incontext");
    }
  }
};
</script>
